import { memo, useCallback, useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'

import ProductDimensionOptionsForm from './product-dimension-options-form'
import { type NormalizedDimension } from './schemas'

import { getUUID } from '~/utils/uuid'

type Props = {
    existingDimensions: NormalizedDimension[]
    nextDimensionIndex: number
    disabledReason: string | null
    onDimensionFormOpen: () => void
    onDimensionAdd: (dimension: NormalizedDimension) => void
}

function ProductDimensionsFooter({
    existingDimensions,
    nextDimensionIndex,
    disabledReason = '',
    onDimensionFormOpen,
    onDimensionAdd,
}: Props) {
    const [isAdding, setIsAdding] = useState(false)

    const closeForm = useCallback(() => setIsAdding(false), [])

    if (isAdding) {
        return (
            <ProductDimensionOptionsForm
                isNewProduct
                existingDimensions={existingDimensions}
                defaultValues={{
                    id: getUUID(),
                    index: nextDimensionIndex,
                    name: '',
                    options: [{ id: getUUID(), name: '' }],
                }}
                onSubmit={(data) => {
                    setIsAdding(false)
                    onDimensionAdd(data)
                }}
                onRemove={closeForm}
                onCancel={closeForm}
            />
        )
    }

    return (
        <Tooltip title={disabledReason}>
            <span>
                <Button
                    color="inherit"
                    disabled={!!disabledReason}
                    startIcon={<AddIcon />}
                    onClick={() => {
                        setIsAdding(true)
                        onDimensionFormOpen()
                    }}
                >
                    {gettext('Add option')}
                </Button>
            </span>
        </Tooltip>
    )
}

export default memo(ProductDimensionsFooter)
